import type { FC, ReactElement } from 'react';

import type { Offer } from '../../../interfaces';
import displayValues from '../../../resources/displayValues.json';

export type OfferMeals = Pick<Offer, 'board'>;

const mealsRecord = displayValues.amenities.meals as Record<string, string>;

export const Meals: FC<OfferMeals> = ({ board }): ReactElement<OfferMeals> | null =>
    board && board !== 'no_meals' ? (
        <div className="text--extra-small" data-testid="offerMeal">
            {mealsRecord[board]}
        </div>
    ) : null;
